// src/router/index.js
import { createRouter, createWebHistory } from "vue-router";
import HomePage from "@/views/HomePage.vue";
import NextPage from "@/views/NextPage.vue";
import ArticleArchivePage from "@/views/ArticleArchivePage.vue";
import AboutPage from "@/views/AboutPage.vue";
import CreatePost from "@/views/CreatePost.vue";
import PostsPage from "@/views/PostsPage.vue";
import PostDetail from "@/views/PostDetail.vue";


const routes = [
  { path: "/", name: "Home", component: HomePage },
  { path: "/next", name: "NextPage", component: NextPage },
  { path: "/article-archives", name: "ArticleArchivePage", component: ArticleArchivePage },
  { path: "/about", name: "AboutPage", component: AboutPage },
  { path: "/posts", name: "PostsPage", component: PostsPage, },
  { path: "/post/:id", name: "PostDetail", component: PostDetail },
  { path: "/create", name: "CreatePost", component: CreatePost, },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
